const selectorsBlog = {
  BUTTON_LOAD_MORE: '.js-button-load-more',
  TEXT_THRESHOLD: '.js-text-threshold',
  THRESHOLD: '.js-threshold',
  HIDDEN_CLASS: 'hidden',
  LOADING_CLASS: 'loading',
  MAIN_BLOG_WRAPPER: '.main-blog__wrapper .main-blog__grid',
  GRID_ITEMS: '.main-blog__wrapper .main-blog__grid .main-blog__item',
  FILTER_CAROUSEL_EL: '.js-main-blog-filter-slide',
  FILTER_LINK_ELS: '.js-main-blog-filter-slide .main-blog__filter-link',
  DEBOUNCE_TIME: 100
}

const container = document.querySelector(selectorsBlog.MAIN_BLOG_WRAPPER)
const buttonLoadMore = document.querySelector(selectorsBlog.BUTTON_LOAD_MORE)
const textThreshold = document.querySelector(selectorsBlog.TEXT_THRESHOLD)
const threshold = document.querySelector(selectorsBlog.THRESHOLD)
const filterCarouselELs = document.querySelectorAll(selectorsBlog.FILTER_CAROUSEL_EL)
const filterLinkELs = document.querySelectorAll(selectorsBlog.FILTER_LINK_ELS)

let currentUrl = new URL(window.location.href)
let currentPage = currentUrl.searchParams.get('page')

let totalPage = window.blogsConfig.totalPagination
let totalBlogs = window.blogsConfig.totalBlogs
let loading = false

var lastScrollTop = 0

const setLocalStorage = (key, value) => {
  try {
    return localStorage.setItem(key, value)
  } catch (err) {
    console.warn('Could not access localStorage with key', key, err)
    return ''
  }
}
const getLocalStorage = (key) => {
  try {
    return localStorage.getItem(key)
  } catch (err) {
    console.warn('Could not access localStorage with key', key, err)
    return ''
  }
}

window.addEventListener('scroll', async () => {
  var scrollTop = window.pageYOffset || document.documentElement.scrollTop
  if (!loading) setLocalStorage('scrollBlog', scrollTop)
})

buttonLoadMore?.addEventListener('click', async () => {
  const gridItems = document.querySelectorAll(selectorsBlog.GRID_ITEMS)
  const lastItem = gridItems[gridItems.length - 1]
  let bottomPage = parseInt(lastItem.getAttribute('data-page'))

  if (bottomPage < totalPage) {
    await loadNewPage('page', bottomPage + 1)
  }
})

const updateThreshold = (page) => {
  if (!threshold && !textThreshold) {
    return
  }

  const currentPage = 12 * page <= totalBlogs ? 12 * page : totalBlogs

  textThreshold.innerHTML = `${currentPage} of ${totalBlogs}`
  threshold.style.width = `calc(${currentPage} / ${totalBlogs} * 100%)`
}

const loadNewPage = async (key, value) => {
  const searchParams = new URLSearchParams(window.location.search)
  searchParams.set(key, value)
  const newRelativePathQuery = window.location.pathname + '?' + searchParams.toString()
  history.pushState(null, '', newRelativePathQuery)
  const newPage = await getBlogs()
  container.innerHTML = container.innerHTML + newPage
  updateThreshold(value)
  masonryLayout(value)
  removePagination(value)

  if (value >= totalPage) {
    buttonLoadMore?.classList.add(selectorsBlog.HIDDEN_CLASS)
  }
  container.classList.remove(selectorsBlog.LOADING_CLASS)
  loading = false
}

const removePagination = (value) => {
  const paginations = document.querySelectorAll('[data-pagination-hidden]')
  paginations.forEach((pagination) => {
    const page = pagination.dataset.page
    if (Number(value) !== Number(page)) {
      pagination.remove()
    }
  })
}

const getBlogs = async (URL) => {
  loading = true
  container.classList.add(selectorsBlog.LOADING_CLASS)

  const url = URL ? URL : window.location.href
  const fetchData = await fetch(`${url}&view=ajax`)

  return await fetchData.text()
}

const initLoadPage = async () => {
  container.classList.add(selectorsBlog.LOADING_CLASS)
  loading = true
  const page = currentPage ? parseInt(currentPage) : 1
  if (page <= 1) {
    container.classList.remove(selectorsBlog.LOADING_CLASS)
    loading = false
    return false
  }

  let html = ''
  for (let i = 1; i <= page; i++) {
    const searchParams = new URLSearchParams(window.location.search)
    searchParams.set('page', i)
    const newRelativePathQuery = window.location.pathname + '?' + searchParams.toString()
    const newPage = await getBlogs(newRelativePathQuery)
    html += newPage
  }
  
  container.innerHTML = html
  removePagination(page)
  // Waiting for HTML apply before scroll to old position
  setTimeout(() => {
    const scrollTo = parseInt(getLocalStorage('scrollBlog'))
    window.scrollTo(0, scrollTo)
    masonryLayout()
  }, 50)

  container.classList.remove(selectorsBlog.LOADING_CLASS)
  loading = false
}

const initFilterCarousel = () => {
  if (!filterCarouselELs) {
    return
  }

  filterCarouselELs.forEach((item) => {
    const carouselConfig = item ? JSON.parse(item.getAttribute('data-option')) : null
    if (carouselConfig) {
      const swiperFilter = new Swiper(item, carouselConfig)
    }
  })
}

const masonryLayout = (page = null) => {
  const gridSelectors = document.querySelectorAll(selectorsBlog.MAIN_BLOG_WRAPPER)

  const marginTopItem = (items, item, index) => {
    if (index % 2 !== 0) {
      const topElementPrev = items[index - 2].offsetTop
      const heightElementPrev = items[index - 2].offsetHeight
      const topCurrentElement = item.offsetTop

      item.style.marginTop = `-${topCurrentElement - topElementPrev - heightElementPrev - 60}px`
    }
  }

  if (gridSelectors?.length > 0) {
    gridSelectors.forEach((gridSelector) => {
      if (!page) {
        const gridItems = gridSelector.querySelectorAll(selectorsBlog.GRID_ITEMS)

        gridItems?.forEach((item, index) => {
          if (index > 1 && window.innerWidth > 1023) {
            marginTopItem(gridItems, item, index)
          } else {
            item.style.marginTop = ''
          }
        })
      } else {
        const gridItems = gridSelector.querySelectorAll(selectorsBlog.GRID_ITEMS)
        const gridItemsPage = gridSelector.querySelectorAll(`[data-page="${page}"]`)

        gridItems?.forEach((gridItem, index) => {
          gridItemsPage.forEach((item, i) => {
            if (gridItem === item) {
              if (window.innerWidth > 1023) {
                marginTopItem(gridItems, gridItem, index)
              }
            }
          })
        })
      }
    })
  }
}

const debounceResize = (func, timeout = 300) => {
  let timer
  return (...args) => {
    clearTimeout(timer)
    timer = setTimeout(() => {
      func.apply(this, args)
    }, timeout)
  }
}
// When clicking on the link
filterLinkELs.forEach(link => {
  link.addEventListener('click', (event) => {
    event.preventDefault()
    const scrollPosition = window.scrollY
    const href = link.getAttribute('href')

    // Update status and history
    history.pushState({ scrollY: scrollPosition }, '', href)
    // Reload page
    window.location.reload()
  })
})

// When loading the page
window.addEventListener('load', () => {
  const state = history.state

  if (state && state.scrollY !== undefined) {
    window.scrollTo(0, state.scrollY)
  }
})

initLoadPage()
masonryLayout()
window.addEventListener(
  'resize',
  debounceResize(() => {
    const gridItems = document.querySelectorAll(selectorsBlog.GRID_ITEMS)
    gridItems.forEach((item) => {
      item.removeAttribute('style')
    })
    masonryLayout()
  }, selectorsBlog.DEBOUNCE_TIME)
)
initFilterCarousel()
